import { Button, Form, Select } from 'antd';
import React, { Component } from 'react';
import axios from 'axios';
import '../SearchForm/SearchForm.css';
import { Constant } from '../../config';

const { Option } = Select;

class Search extends Component {
  state = {
    countryList: [],
	}

  async componentDidMount() {
    if (typeof this.props.onRef === 'function') this.props.onRef(this);
    this.setState({
  		countryList: await this._getCountryList(),
  	})
  }

  _getCountryList = async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    let rtn = [{ region_code: '', name: 'All Country' }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.fn(this.props.form);
  };

  handleReset = () => {
    this.props.form.resetFields();
    this.props.fnReset();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form className="search-frm" layout="inline" onSubmit={this.handleSubmit}>
        <Form.Item>
          {getFieldDecorator('country', {
            rules: [{ required: false }],
          })(
            <Select
              showSearch
              placeholder="Country"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '200px' }}
            >
              {(this.state.countryList || []).map((item, i) => (
                <Option key={i} value={item.region_code}>
                  {item.name}
                </Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item>
          <Button.Group>
            <Button htmlType="submit" icon="search" />
            <Button icon="redo" onClick={this.handleReset} />
          </Button.Group>
        </Form.Item>
      </Form>
    );
  }
}

const DropdownCountry = Form.create({ name: 'search-frm' })(Search);

export default DropdownCountry;



// WEBPACK FOOTER //
// ./src/containers/SearchForm/dropdown-country.js